import React from "react";
import Headerdash from "../head";
import Sidebar from "../sidebar";
import { useNavigate } from "react-router-dom";
import AudioPlayer from "../QuestionPage/AudioPlayer";

import { useState, useEffect } from "react";
import MockNavigation from "./MockNavigation";

// Fetching Data from the API]

// End

// Page Html
export default function WritingSectionTablePage() {
  // End
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/");
  };

  const [audioLink, setaudioLink] = useState("");

  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h1 className="text-2xl pt-3 font-bold text-gray-900 sm:text-3xl ml-1 text-center md:text-start">
          Welcome
        </h1>
        <div class="container pt-5">
          <table class="min-w-full text-left">
            <thead>
              <tr>
                <th class="px-6 py-3 border-2 bg-gray-100 text-black">Part</th>
                <th class="px-6 py-3 border-2 bg-gray-100 text-black">Content</th>
                <th class="px-6 py-3 border-2 bg-gray-100 text-black">
                  Time Allowed
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="border-2 px-6 py-4">1</td>
                <td class="border-2 px-6 py-4">Writing</td>
                <td class="border-2 px-6 py-4">40 Minutes</td>
              </tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
